import { render, staticRenderFns } from "./LinkMenu.vue?vue&type=template&id=ad815534&scoped=true"
import script from "./LinkMenu.vue?vue&type=script&lang=js"
export * from "./LinkMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad815534",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad815534')) {
      api.createRecord('ad815534', component.options)
    } else {
      api.reload('ad815534', component.options)
    }
    module.hot.accept("./LinkMenu.vue?vue&type=template&id=ad815534&scoped=true", function () {
      api.rerender('ad815534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stickerMenu/LinkMenu.vue"
export default component.exports